import engineeringMinds from "../Images/client/media/news/engineering-minds.jpeg";
import krishiMelaGkvk from "../Images/client/media/news/krishi-mela-gkvk.jpeg";
import eKunteNews from "../Images/client/media/news/News article on e-Kunte Weeder.png";
import gkvkKrishimelaCoverage from "../Images/client/media/news/GKVK Krishimela coverage .png";
import catalogCover from "../Images/client/media/catalog/sna-product-catalog-2026-cover.png";
import octoberKrishimela from "../Images/client/media/events/october-2025-krishimela.jpg";
import novemberGkvk from "../Images/client/media/events/november-2025-gkvk-krishimela.jpg";
import decemberMandya from "../Images/client/media/events/december-2025-mandya-krishimela.jpg";
import februaryKisan from "../Images/client/media/events/february-march-2026-kisan-swaraj.jpg";
import brushCutterOperation from "../Images/client/media/gallery/Brush Cutter Operation.jpg";
import eTrolleyInAction from "../Images/client/media/gallery/E trolley in action.jpg";
import effectivePoultryRaking from "../Images/client/media/gallery/Effective Poultry Raking.jpg";
import electricConoWeederInAction from "../Images/client/media/gallery/Electric Cono Weeder in action.jpg";
import electricPaddyWeeder from "../Images/client/media/gallery/Electric Paddy Weeder_.jpg";
import farmersMeetup from "../Images/client/media/gallery/Farmers meetup.jpg";
import fieldVisitSingleWheelWeeder from "../Images/client/media/gallery/Field Visit - Single Wheel Weeder_.jpg";
import fieldVisitBagalkot from "../Images/client/media/gallery/Field Visit Bagalkot.jpg";
import fieldVisitMandya from "../Images/client/media/gallery/Field Visit Mandya .jpeg";
import happyCustomerPoultryRaking from "../Images/client/media/gallery/Happy customer with Poultry Raking machine.jpg";
import onFieldTrainingWeederUsage from "../Images/client/media/gallery/On Field Training of weeder usage.jpg";
import onFieldWeederDemo from "../Images/client/media/gallery/On-Field Weeder Demo_.jpg";
import onFieldPaddyDemo from "../Images/client/media/gallery/On-field Paddy demo.jpg";
import paddyWeederLineSowing from "../Images/client/media/gallery/Paddy Weeder in line sowing.jpg";
import paddyWeederMachineTransplanted from "../Images/client/media/gallery/Paddy Weeder in machine transplanted field.jpg";
import paddyWeederWithVle from "../Images/client/media/gallery/Paddy Weeder with VLE.jpg";
import poultryRakingDemo from "../Images/client/media/gallery/Poultry Raking Demo.jpg";
import sww from "../Images/client/media/gallery/SWW.png";
import sidepackBrushCutter from "../Images/client/media/gallery/Sidepack Brush cutter.jpg";
import sidepackBrushCutterOne from "../Images/client/media/gallery/Sidepack brush cutter(1).jpg";
import singleWheelWeederOne from "../Images/client/media/gallery/Single Wheel Weeder(1).jpg";
import singleWheelWeeder from "../Images/client/media/gallery/Single Wheel Weeder.jpg";
import womenFarmerBrushCutter from "../Images/client/media/gallery/Women Farmer with Brush Cutter_.jpg";
import womenFarmersWeeders from "../Images/client/media/gallery/Women Farmers with weeders.jpg";
import womenVleBatteryWeeder from "../Images/client/media/gallery/Women VLE with Battery Weeder.jpg";
import womenFriendlyWeeder from "../Images/client/media/gallery/Women friendly weeder.jpg";
import eKunte from "../Images/client/media/gallery/e-Kunte.jpg";

export const galleryPhotos = [
  {
    id: "brush-cutter-operation",
    src: brushCutterOperation,
    title: "Brush Cutter Operation",
    caption: "Brush Cutter Operation",
    alt: "Brush Cutter Operation.",
  },
  { id: "e-trolley-in-action", src: eTrolleyInAction, title: "E trolley in action", caption: "E trolley in action", alt: "E trolley in action." },
  { id: "effective-poultry-raking", src: effectivePoultryRaking, title: "Effective Poultry Raking", caption: "Effective Poultry Raking", alt: "Effective Poultry Raking." },
  { id: "electric-cono-weeder-in-action", src: electricConoWeederInAction, title: "Electric Cono Weeder in action", caption: "Electric Cono Weeder in action", alt: "Electric Cono Weeder in action." },
  { id: "electric-paddy-weeder", src: electricPaddyWeeder, title: "Electric Paddy Weeder", caption: "Electric Paddy Weeder", alt: "Electric Paddy Weeder." },
  { id: "farmers-meetup", src: farmersMeetup, title: "Farmers meetup", caption: "Farmers meetup", alt: "Farmers meetup." },
  { id: "field-visit-single-wheel-weeder", src: fieldVisitSingleWheelWeeder, title: "Field Visit - Single Wheel Weeder", caption: "Field Visit - Single Wheel Weeder", alt: "Field Visit - Single Wheel Weeder." },
  { id: "field-visit-bagalkot", src: fieldVisitBagalkot, title: "Field Visit Bagalkot", caption: "Field Visit Bagalkot", alt: "Field Visit Bagalkot." },
  { id: "field-visit-mandya", src: fieldVisitMandya, title: "Field Visit Mandya", caption: "Field Visit Mandya", alt: "Field Visit Mandya." },
  { id: "happy-customer-with-poultry-raking-machine", src: happyCustomerPoultryRaking, title: "Happy customer with Poultry Raking machine", caption: "Happy customer with Poultry Raking machine", alt: "Happy customer with Poultry Raking machine." },
  { id: "on-field-training-of-weeder-usage", src: onFieldTrainingWeederUsage, title: "On Field Training of weeder usage", caption: "On Field Training of weeder usage", alt: "On Field Training of weeder usage." },
  { id: "on-field-weeder-demo", src: onFieldWeederDemo, title: "On-Field Weeder Demo", caption: "On-Field Weeder Demo", alt: "On-Field Weeder Demo." },
  { id: "on-field-paddy-demo", src: onFieldPaddyDemo, title: "On-field Paddy demo", caption: "On-field Paddy demo", alt: "On-field Paddy demo." },
  { id: "paddy-weeder-in-line-sowing", src: paddyWeederLineSowing, title: "Paddy Weeder in line sowing", caption: "Paddy Weeder in line sowing", alt: "Paddy Weeder in line sowing." },
  { id: "paddy-weeder-in-machine-transplanted-field", src: paddyWeederMachineTransplanted, title: "Paddy Weeder in machine transplanted field", caption: "Paddy Weeder in machine transplanted field", alt: "Paddy Weeder in machine transplanted field." },
  { id: "paddy-weeder-with-vle", src: paddyWeederWithVle, title: "Paddy Weeder with VLE", caption: "Paddy Weeder with VLE", alt: "Paddy Weeder with VLE." },
  { id: "poultry-raking-demo", src: poultryRakingDemo, title: "Poultry Raking Demo", caption: "Poultry Raking Demo", alt: "Poultry Raking Demo." },
  { id: "sww", src: sww, title: "SWW", caption: "SWW", alt: "SWW." },
  { id: "sidepack-brush-cutter", src: sidepackBrushCutter, title: "Sidepack Brush cutter", caption: "Sidepack Brush cutter", alt: "Sidepack Brush cutter." },
  { id: "sidepack-brush-cutter-1", src: sidepackBrushCutterOne, title: "Sidepack brush cutter(1)", caption: "Sidepack brush cutter(1)", alt: "Sidepack brush cutter(1)." },
  { id: "single-wheel-weeder-1", src: singleWheelWeederOne, title: "Single Wheel Weeder(1)", caption: "Single Wheel Weeder(1)", alt: "Single Wheel Weeder(1)." },
  { id: "single-wheel-weeder", src: singleWheelWeeder, title: "Single Wheel Weeder", caption: "Single Wheel Weeder", alt: "Single Wheel Weeder." },
  { id: "women-farmer-with-brush-cutter", src: womenFarmerBrushCutter, title: "Women Farmer with Brush Cutter", caption: "Women Farmer with Brush Cutter", alt: "Women Farmer with Brush Cutter." },
  { id: "women-farmers-with-weeders", src: womenFarmersWeeders, title: "Women Farmers with weeders", caption: "Women Farmers with weeders", alt: "Women Farmers with weeders." },
  { id: "women-vle-with-battery-weeder", src: womenVleBatteryWeeder, title: "Women VLE with Battery Weeder", caption: "Women VLE with Battery Weeder", alt: "Women VLE with Battery Weeder." },
  { id: "women-friendly-weeder", src: womenFriendlyWeeder, title: "Women friendly weeder", caption: "Women friendly weeder", alt: "Women friendly weeder." },
  { id: "e-kunte", src: eKunte, title: "e-Kunte", caption: "e-Kunte", alt: "e-Kunte." },
];

export const mediaVideos = [
  { id: "3-QyY33c-Ic", title: "Single Wheel Weeder", heading: "Single Wheel Weeder" },
  { id: "oRZ_8-8BeDY", title: "Electric Cono Weeder", heading: "Electric Cono Weeder" },
  { id: "whubCxXBEQk", title: "Poultry Raking Machine", heading: "Poultry Raking Machine" },
  { id: "44khpJEHba8", title: "Trolley Brush Cutter", heading: "Trolley Brush Cutter" },
  { id: "PZVKshjESgk", title: "Electric paddy weeder", heading: "Electric paddy weeder" },
  { id: "Rat-pH7Ku2Q", title: "Single Wheel Weeder", heading: "Single Wheel Weeder" },
  { id: "4zGTpkQTdhQ", title: "Poultry Raking Machine", heading: "Poultry Raking Machine" },
  { id: "2em6t0-Uu2k", title: "Side pack Brush Cutter", heading: "Side pack Brush Cutter" },
];

export const newsItems = [
  {
    id: "engineering-minds",
    src: engineeringMinds,
    title: "Engineering Minds feature",
    caption: "Press clipping about Suryanirbhar Agritech and farming-focused engineering.",
    alt: "Press clipping titled Engineering Minds featuring Suryanirbhar Agritech.",
    source: "SNB /Photos/News/Engineers day.jpeg",
  },
  {
    id: "krishi-mela-gkvk",
    src: krishiMelaGkvk,
    title: "Krishi Mela press clipping",
    caption: "Press clipping about Krishi Mela and technology-driven agricultural growth.",
    alt: "Newspaper clipping about Krishi Mela with agricultural machinery photographs.",
    source: "SNB /Photos/News/KM GKVK.jpeg",
  },
  {
    id: "news-article-on-e-kunte-weeder",
    src: eKunteNews,
    title: "News article on e-Kunte Weeder",
    caption: "Press clipping about the e-Kunte Weeder.",
    alt: "News article on e-Kunte Weeder.",
    source: "src/Images/client/media/news/News article on e-Kunte Weeder.png",
  },
  {
    id: "gkvk-krishimela-coverage",
    src: gkvkKrishimelaCoverage,
    title: "GKVK Krishimela coverage",
    caption: "Press clipping about GKVK Krishimela coverage.",
    alt: "GKVK Krishimela coverage news clipping.",
    source: "src/Images/client/media/news/GKVK Krishimela coverage .png",
  },
];

export const eventStories = [
  {
    id: "october-krishimela",
    title: "Krishimela demonstrations across Karnataka",
    meta: "October 2025 newsletter",
    src: octoberKrishimela,
    alt: "Newsletter page about Krishimela activity and field demonstrations in October 2025.",
    description: "The October 2025 newsletter reports Krishimela activity across Karnataka, including Dharwad and Bramhavara, where people were introduced to the Weeding as a Service model.",
    source: "SNB Newsletter - October 2025, page 1",
    derived: true,
  },
  {
    id: "november-gkvk",
    title: "GKVK Krishi Mela 2025",
    meta: "November 2025 newsletter",
    src: novemberGkvk,
    alt: "Newsletter page describing Suryanirbhar participation in GKVK Krishi Mela 2025.",
    description: "The November 2025 newsletter states that Suryanirbhar exhibited at GKVK Krishi Mela at UAS Bengaluru and received farmer interest in electric weeders and poultry raking machines.",
    source: "SNB Newsletter - November 2025, page 3",
    derived: true,
  },
  {
    id: "december-mandya",
    title: "Mandya Krishi Mela at VC Farm",
    meta: "December 2025 newsletter",
    src: decemberMandya,
    alt: "Newsletter page about participation in Mandya Krishi Mela at VC Farm.",
    description: "The December 2025 newsletter reports Suryanirbhar's participation at VC Farm, Mandya Krishi Mela, including paddy equipment demos with support from Puttannaiah Foundation.",
    source: "SNB Newsletter - December 2025, page 3",
    derived: true,
  },
  {
    id: "kisan-swaraj",
    title: "Kisan Swaraj Sammelan, Mysore",
    meta: "February/March 2026 newsletter",
    src: februaryKisan,
    alt: "Newsletter page about Kisan Swaraj Sammelan, Mysore and Rainmatter Climate Founders Day.",
    description: "The February/March 2026 newsletter reports Suryanirbhar participation at Kisan Swaraj Sammelan in Mysore, with farmers, FPOs, NGOs and companies expressing interest in collaboration.",
    source: "SNB Newsletter - February/March 2026, page 3",
    derived: true,
  },
];

export const catalogs = [
  {
    title: "SNA Product Catalog 2026",
    caption: "Suryanirbhar Agritech product catalog.",
    file: "/ProductCatalog/catalog.pdf",
    fileName: "SNA Product Catalog 2026.pdf",
    cover: catalogCover,
    source: "SNB /Catalog/SNA Product Catalog.pdf and existing public/ProductCatalog/catalog.pdf are byte-identical.",
  },
];
